import React, { PropTypes, Component } from 'react'
import Table from 'react-bootstrap/lib/Table'
import acc from 'accounting'

import ListSubjectsTable from './list-subjects-table'

class ListSubjects extends Component {

  _renderList() {
    const { subjectList, onSelectItem } = this.props

    return (
      <div>
        {subjectList.get('data') && subjectList.get('data').map((semSubjects, i) => (
          <ListSubjectsTable
            key={i}
            semSubjects={semSubjects}
            onSelectItem={onSelectItem}
          />
        ))}
      </div>
    )
  }

  _renderMeta() {
    const { subjectList } = this.props
    const lec = acc.formatNumber(subjectList.getIn(['meta', 'total_lec']), 1)
    const lab = acc.formatNumber(subjectList.getIn(['meta', 'total_lab']), 1)
    const total = acc.formatNumber(subjectList.getIn(['meta', 'total']), 1)

    return (
      <Table condensed hover>
        <thead>
          <tr className="info">
            <th width="67%" colSpan="3" className="text-right">Total:</th>
            <th width="6%" className="text-right">{lec}</th>
            <th width="6%" className="text-right">{lab}</th>
            <th width="6%" className="text-right">{total}</th>
            <th width="15%">{' '}</th>
          </tr>
        </thead>
      </Table>
    )
  }

  render() {
    return (
      <div>
        {this._renderList()}
        {this._renderMeta()}
      </div>
    )
  }
}

ListSubjects.propTypes = {
  subjectList: PropTypes.object,
  onSelectItem: PropTypes.func,
}

export default ListSubjects



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/list-subjects.js